import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Taxidalogo from "../../../assets/images/Taxidaicon.svg";
import Arrow from "../../../assets/images/arrow-b.svg";
import Search from "../../../assets/images/search.svg";
import Logo from "../../../assets/images/Logo-t.svg";
import Add from "../../../assets/images/addicon.svg";
import Bell from "../../../assets/images/bell.svg";
import userlogo from "../../../assets/images/Avatar.svg";
import "./header.scss";
import AccessControl from "../../access-control";
import Authorization from "../../../utility/authorization";
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.authUser = this.props.auth.getAuthUser();
    this.roleId = Authorization.getAuthRoleId();
    console.log({ gwdygydhvwhwhhwd: this.roleId });
  }
  state = {
    headerClass: "dropdown-content",
    sidebarOpen: false,
    menu_class: "",
  };

  toggleHeaderMenu = () => {
    this.setState({
      headerClass:
        this.state.headerClass === "dropdown-content"
          ? `${this.state.headerClass} responsive`
          : "dropdown-content",
    });
  };
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (e) => {
    if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.setState({
        headerClass: "dropdown-content",
      });
    }
  };
  /**
   * Method is to toggle sidebar
   */
  toggleSidebar = () => {
    this.props.dispatch({
      type: "TOGGLE_SIDEBAR",
      payload: { visible: !this.props.sidebar.visible },
    });
  };

  setToggleTopMenuClass = () => {
    if (this.state.menu_class === "") {
      this.setState({
        menu_class: "toggled",
      });
    } else {
      this.setState({
        menu_class: "",
      });
    }
  };

  render() {
    const userRole = this.authUser.roleId || 0;
    const {
      sidebar: { visible: isOpen },
    } = this.props;
    const { userInfo } = this.props.companyInfo || "";
    const { companyName } = userInfo || {};
    const header_menu_class = `fixed-header ${this.state.menu_class}`;
    const { name, lastName, email, countryCode, phone } = this.authUser;
    console.log({ asdfgf: this.authUser });

    return (
      <div>
        <header className={header_menu_class}>
          <div className="main-head">
            <span
              className="main-logo main-bg"
              style={{
                display: isOpen ? "inline-flex" : "none",
                cursor: "default",
              }}
            >
              <img className="logo" src={Logo} alt="main-logo" />
            </span>
          </div>
          {/*<button
            type="button"
            className={
              !this.props.sidebar.visible
                ? "pe-none toggle-menu"
                : "toggle-menu"
            }
            onClick={this.toggleSidebar}
          >
            <img src={Arrow} alt="toggle-img" />
          </button>*/}

          <div className="main-sub">
            <div className="head-options">
              {/*<div className="search-bar">
            <img src={Search} alt="search" />
            <input type="text" className="s-input" placeholder="What are you looking for?" />
          </div>
            <button className="head-button">
              <span className="text">
              Go to Market
              </span>
          </button>*/}
              <h4>{companyName}</h4>
            </div>
            <ul ref={this.setWrapperRef} className="anchorList ml-auto">
              <Link className="" to="/profile">
                <img className="drop-down" src={userlogo} alt="user-logo"></img>
              </Link>
            </ul>
          </div>
        </header>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    sidebar: state.sidebar,
  };
})(Header);
